import { useApi } from '@omnipresentgroup/api';
import type {
  GetMergeIntegrationResponseAPI,
  MergeIntegration,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { INTEGRATION_API_BASE } from '../constants';
import { transformMergeIntegrationFromAPI } from '../mappers';

export const INTEGRATION_STATUS_PATH = 'integration/status';

export const getMergeIntegrationKey = () => [INTEGRATION_STATUS_PATH];

export const useMergeIntegration = () => {
  const { GET } = useApi();

  return useQuery<GetMergeIntegrationResponseAPI, unknown, MergeIntegration>({
    queryKey: getMergeIntegrationKey(),
    queryFn: () =>
      GET<GetMergeIntegrationResponseAPI>(
        `${INTEGRATION_API_BASE}/${INTEGRATION_STATUS_PATH}`,
        {},
      ),
    select: transformMergeIntegrationFromAPI,
  });
};
